import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react';
import type { HeaderNavigationProps } from '../components/HeaderNavigation';

type HeaderNavigationConfig = Omit<HeaderNavigationProps, 'className'>;

type HeaderNavigationContextValue = {
  config: HeaderNavigationConfig | null;
  setConfig: (config: HeaderNavigationConfig | null) => void;
};

const HeaderNavigationContext = createContext<HeaderNavigationContextValue>({
  config: null,
  setConfig: () => {},
});

export function HeaderNavigationProvider({ children }: { children: ReactNode }) {
  const [config, setConfigState] = useState<HeaderNavigationConfig | null>(null);

  const setConfig = useCallback((next: HeaderNavigationConfig | null) => {
    setConfigState(next);
  }, []);

  return (
    <HeaderNavigationContext.Provider value={{ config, setConfig }}>
      {children}
    </HeaderNavigationContext.Provider>
  );
}

export function useHeaderNavigationContext(): HeaderNavigationContextValue {
  return useContext(HeaderNavigationContext);
}
